import { api } from "@/lib/api"

/** Tiers and statuses in use across companies, read on the server instead of syncing every company. */
export function useCompanyAttributeValues() {
	const { data } = api.company.attributeValues.useQuery(undefined, {
		staleTime: 60_000,
	})
	return {
		tiers: data?.tiers ?? [],
		statuses: (data?.statuses ?? []).flatMap((status) =>
			status.color ? [{ name: status.name, color: status.color }] : [],
		),
	}
}
